import React from "react";
import QuestionsTab from "./QuestionsTab";

const QuickAnswers = () => {
  const faqs = [
    {
      ques: "How reliable is tampering detection?",
      ans:
        "The analyser inspects metadata, edits, and overlays, assigning a tampering score so teams can trust document authenticity before approval.",
    },
    {
      ques: "How accurate is ABB calculation compared to manual review?",
      ans:
        "ABB is calculated for full periods and key dates, adjusted for bounces and volatility, giving a truer repayment capacity picture.",
    },
    {
      ques: "Can income and sources of funds be separated clearly?",
      ans:
        "Yes. Salary, rent, and business inflows are auto-classified, making it simple to identify primary income and verify financial stability.",
    },
    {
      ques: "Does it support all types of bank account statements?",
      ans:
        "Yes. It works seamlessly across 100+ savings and current account formats, whether uploaded as PDFs or integrated through APIs.",
    },
    {
      ques: "How easy is integration with our existing systems?",
      ans:
        "Integration is simple. Reports connect directly to LOS or LMS via APIs, so teams don’t need to change existing workflows.",
    },
    {
      ques: "Can it handle bulk statement reviews?",
      ans:
        "Yes. Hundreds of statements can be uploaded or integrated at once, allowing teams to scale reviews without slowing operations.",
    },
  ];

  return (
    <div className="faq-wrapper">
      <div className="faq-heading">
        Quick Answers for
        <span style={{ color: "#6D2FEC" }}> Credit</span> Teams
      </div>
      <div className="faq-questions-tab">
        {faqs?.map((faq, index) => {
          return (
            <>
              <QuestionsTab ques={faq?.ques} ans={faq?.ans} key={index} />
            </>
          );
        })}
      </div>
    </div>
  );
};

export default QuickAnswers;
